var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgZoomInO = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M9.167 3.333a5.833 5.833 0 1 0 4.047 10.035.9.9 0 0 1 .154-.154 5.833 5.833 0 0 0-4.201-9.88m5.86 10.515a7.5 7.5 0 1 0-1.178 1.178l3.062 3.063a.833.833 0 1 0 1.178-1.178zm-5.86-8.015c.46 0 .833.373.833.834v1.666h1.667a.833.833 0 1 1 0 1.667H10v1.667a.833.833 0 1 1-1.667 0V10H6.667a.833.833 0 0 1 0-1.667h1.666V6.667c0-.46.374-.834.834-.834",
  clipRule: "evenodd"
})));
export default SvgZoomInO;